import { HttpClientModule } from '@angular/common/http'
import { ApplicationRef, DoBootstrap, NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { SpartacusModule } from './spartacus/spartacus.module'
import { MbModule } from './mb/mb.module'
import { CookieService } from 'ngx-cookie-service'
import { WindowRef } from '@spartacus/core'
import { TransferHttpCacheModule } from '@nguniversal/common'
import { UserCentrics } from './mb/cms/components/types'
import { optionalModules } from '../environments/optional-modules/optional-modules'

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'mb-root' }),
    AppRoutingModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    HttpClientModule,
    TransferHttpCacheModule,
    SpartacusModule,
    MbModule,

    // Include optional modules depending on the environment
    ...optionalModules
    // TODO remove. Temporary until SSR issues are solved
    // TODO: Spartacus Upgrade - ngx-zone-task-tracking needs Angular13; it has no other version
    // ZoneTaskTrackingModule.printWithDelay(5000)
  ],
  providers: [
    CookieService
  ]
})
export class AppModule implements DoBootstrap {
  constructor (protected winRef: WindowRef) {
  }

  ngDoBootstrap (appRef: ApplicationRef) {
    appRef.bootstrap(AppComponent)
    if (this.winRef.nativeWindow?.Cypress) {
      this.winRef.nativeWindow.appRef = appRef
    }
  }
}

declare global {
  interface Window {
    Cypress: any;
    appRef: ApplicationRef;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    UC_UI: UserCentrics;
  }
}
